<div [style.height.px]="this.props['height']"></div>